import { bookDetailsActionTypes } from './Constants';

const initialState = {
	loading: false,
	availableTracks: [],
	availableEditionsTrackWise: [],
	chapters: [],
	btnLoading: false,
	subjectBooksData: [],
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case bookDetailsActionTypes.GET_BOOK_DETAILS_REQUEST:
			return {
				loading: true,
				availableTracks: [],
				availableEditionsTrackWise: [],
				chapters: [],
				subjectBooksData: [],
				btnLoading: false,
			};

		case bookDetailsActionTypes.CLEAR_BOOKS_DETAILS:
			return initialState;

		case bookDetailsActionTypes.GET_BOOK_DETAILS_SUCCESS:
			const bookGrades = data.publisher_method_books_per_combined_grade;
			const bookGrade = bookGrades.filter(
				(item) => item.book_grade_display === data.book_grade_display,
			)[0];
			const bookEditions = bookGrade.books.map((item) => ({
				...item,
				book_grade_display: bookGrade.book_grade_display,
			}));
			const bookEdition = bookGrade.books.filter((item) => item.id === data.id)[0];

			return {
				loading: false,
				...data,
				bookGrades,
				bookGrade,
				bookEditions,
				bookEdition,
				subjectBooksData: data.subject_books,
			};

		case bookDetailsActionTypes.GET_BOOK_DETAILS_ERROR:
			return {
				...state,
				loading: false,
			};

		case bookDetailsActionTypes.ADD_TO_MY_BOOKS_REQUEST:
		case bookDetailsActionTypes.REMOVE_FROM_MY_BOOKS_REQUEST:
			return {
				...state,
				btnLoading: true,
			};

		case bookDetailsActionTypes.REMOVE_FROM_MY_BOOKS_SUCCESS:
		case bookDetailsActionTypes.ADD_TO_MY_BOOKS_ERROR:
		case bookDetailsActionTypes.REMOVE_FROM_MY_BOOKS_ERROR:
			return {
				...state,
				btnLoading: false,
			};

		case bookDetailsActionTypes.ADD_TO_MY_BOOKS_SUCCESS:
			return {
				...state,
				btnLoading: false,
				subjectBooksData: data,
			};

		default:
			return state;
	}
}
